module.exports = __webpack_public_path__ + "img/engine-2.78777002.png";